function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8906 1.40625H15.0469V0H13.6406V1.40625H4.35938V0H2.95312V1.40625H2.10938C0.946266 1.40625 0 2.35252 0 3.51562V15.8906C0 17.0537 0.946266 18 2.10938 18H15.8906C17.0537 18 18 17.0537 18 15.8906V3.51562C18 2.35252 17.0537 1.40625 15.8906 1.40625ZM16.5938 15.8906C16.5938 16.2783 16.2783 16.5938 15.8906 16.5938H2.10938C1.72167 16.5938 1.40625 16.2783 1.40625 15.8906V6.60938H16.5938V15.8906ZM16.5938 5.20312H1.40625V3.51562C1.40625 3.12792 1.72167 2.8125 2.10938 2.8125H2.95312V4.21875H4.35938V2.8125H13.6406V4.21875H15.0469V2.8125H15.8906C16.2783 2.8125 16.5938 3.12792 16.5938 3.51562V5.20312Z",
  fill: "#5FCA77"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.07812 8.08594H2.67188V9.49219H4.07812V8.08594Z",
  fill: "#5FCA77"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.89062 8.08594H5.48438V9.49219H6.89062V8.08594Z",
  fill: "#5FCA77"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.70312 8.08594H8.29688V9.49219H9.70312V8.08594Z",
  fill: "#5FCA77"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5156 8.08594H11.1094V9.49219H12.5156V8.08594Z",
  fill: "#5FCA77"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3281 8.08594H13.9219V9.49219H15.3281V8.08594Z",
  fill: "#5FCA77"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.07812 10.8984H2.67188V12.3047H4.07812V10.8984Z",
  fill: "#5FCA77"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.89062 10.8984H5.48438V12.3047H6.89062V10.8984Z",
  fill: "#5FCA77"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M9.70312 10.8984H8.29688V12.3047H9.70312V10.8984Z",
  fill: "#5FCA77"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5156 10.8984H11.1094V12.3047H12.5156V10.8984Z",
  fill: "#5FCA77"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M4.07812 13.7109H2.67188V15.1172H4.07812V13.7109Z",
  fill: "#5FCA77"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M6.89062 13.7109H5.48438V15.1172H6.89062V13.7109Z",
  fill: "#5FCA77"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M9.70312 13.7109H8.29688V15.1172H9.70312V13.7109Z",
  fill: "#5FCA77"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5156 13.7109H11.1094V15.1172H12.5156V13.7109Z",
  fill: "#5FCA77"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3281 10.8984H13.9219V12.3047H15.3281V10.8984Z",
  fill: "#5FCA77"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.aae14a83.svg";
export { ForwardRef as ReactComponent };